(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    // Close share popup when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.product-share-button')) {
      document.querySelectorAll('.share-popup--open').forEach(function(p) {
        p.classList.remove('share-popup--open');
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
